import React from 'react';
import Layout from '../../components/Layout';
import PRO from './PRO';
import getUser from '../../utils/getUser';
import isPro from '../../data/fetch/isPro';
import PROActive from './active/PROActive';
import getSubscription from '../../data/fetch/getSubscription';

async function action({ fetch }) {
	const user = getUser();
	let pro = false;
	let subscription = null;

	if (user) {
		pro = await isPro(fetch);
		subscription = await getSubscription(fetch);
	}

	return {
		title: 'New Tab Studio PRO — Unlimited Widgets',
		titleFull: true,
		description:
			'PRO removes the limit on widgets you add by hand, allows unlimited habit trackers, and unlocks daily and weekly countdown repeats, the workday countdown and analog clock timezones.',
		chunks: ['pro'],
		// Единственная страница с чекаутом Paddle
		paddle: true,
		component: (
			<Layout>
				<div id="div1">
					{pro && <PROActive subscription={subscription} />}
				</div>

				<div id="div2">{!pro && <PRO />}</div>
			</Layout>
		),
	};
}

export default action;
